import { ApiService } from '../parents/api.service';
import { HttpApiClient } from '../api/http-api-client';
import { OrderAddressModel } from '../models/order-address.model';

export class OrderAddressesApiService extends ApiService {
  static endpoint = 'orders/{orderId}/addresses';

  /**
   * @param {String} orderId
   * @param {Number|null} id
   * @return {String}
   * @protected
   */
  static buildOrderUrl(orderId, id = null) {
    return this.buildUrl(id).replace('{orderId}', orderId);
  }

  /**
   * @param {String} orderId
   * @param {Object} data
   * @param {builderCallback} builderCallback
   * @param {Object} config
   * @return {Promise<ApiResponse<OrderModel|ApiResponse>>}
   * @public
   */
  static async patchBilling(orderId, data, builderCallback = null, config = {}) {
    return HttpApiClient.patch(this.buildOrderUrl(orderId, 'billing'), data, {
      ...config,
      dataModel: OrderAddressModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }

  /**
   * @param {String} orderId
   * @param {Object} data
   * @param {builderCallback} builderCallback
   * @param {Object} config
   * @return {Promise<ApiResponse<OrderModel|ApiResponse>>}
   * @public
   */
  static async patchShipping(orderId, data, builderCallback = null, config = {}) {
    return HttpApiClient.patch(this.buildOrderUrl(orderId, 'shipping'), data, {
      ...config,
      dataModel: OrderAddressModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }

  /**
   * @param {String} orderId
   * @param {builderCallback|null} builderCallback
   * @param {Object} config
   * @return {Promise<ApiResponse<OrderAddressModel>>}
   * @public
   */
  static getAll(orderId, builderCallback = null, config = {}) {
    return HttpApiClient.get(this.buildOrderUrl(orderId), {
      ...config,
      dataModel: OrderAddressModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }
}
